/**
 * Calculates the total amount due for a loan
 */
export const calculateAmountDue = (dates, payments, endDate = new Date()) => {
    const compareDate = typeof endDate === 'string' ? new Date(endDate) : endDate;
    
    // Calculate total due amount up to end date
    const totalDueAmount = dates
        .filter(date => new Date(date.date) <= compareDate)
        .reduce((sum, date) => sum + parseFloat(date.dueAmount), 0);

    // Calculate total payments made up to end date using individual components
    const totalPaidAmount = payments
        .filter(payment => new Date(payment.paymentDate) <= compareDate)
        .reduce((sum, payment) => 
            sum + 
            parseFloat(payment.paidPrincipal || 0) + 
            parseFloat(payment.paidInterest || 0) + 
            parseFloat(payment.paidOther || 0), 0);

    // Return remaining amount due
    return Math.max(0, totalDueAmount - totalPaidAmount);
};

/**
 * Calculates the penalty amount for a loan
 */
export const calculatePenalty = (dates, payments, endDate = new Date()) => {
    const compareDate = typeof endDate === 'string' ? new Date(endDate) : endDate;
    
    // Get base amount due
    const baseAmountDue = calculateAmountDue(dates, payments, endDate);
    
    if (baseAmountDue <= 0) return 0;

    // Get the last payment date or the date granted if no payments
    const sortedPayments = [...payments].sort((a, b) => 
        new Date(b.paymentDate) - new Date(a.paymentDate)
    );

    const lastActivityDate = sortedPayments.length > 0 
        ? new Date(sortedPayments[0].paymentDate)
        : new Date(dates[0].date);

    // Calculate days since last payment
    const daysSinceLastPayment = Math.floor(
        (compareDate - lastActivityDate) / (1000 * 60 * 60 * 24)
    );

    // Calculate complete 31-day periods
    const periodsOf31Days = Math.floor(daysSinceLastPayment / 31);

    // Calculate penalty (1.5% of base amount per period)
    return periodsOf31Days >= 2 ? baseAmountDue * 0.015 * periodsOf31Days : 0;
};